import apiClient from "config/apiClient";
import { BrandDetailTireSelectResponse, BrandDetailTireUpdateRequest } from "../types/tire";
import { BrandDetailParams } from "../../proc_fee/types/tire";

/**
 * Fetches the tire detail selection from the API.
 *
 * This function sends a POST request to the endpoint
 * "/mst/item/brand/detail/tire/select" and returns the response data.
 * @param params - The pagination parameters for the API request.
 * @returns {Promise<BrandDetailTireSelectResponse>} A promise that resolves to the tire detail selection response.
 */
const getTireDetailSelect = async (
  params: BrandDetailParams,
): Promise<BrandDetailTireSelectResponse | undefined> => {
  const response = await apiClient.post<BrandDetailTireSelectResponse>(
    "/mst/item/brand/detail/tire/select",
    params,
  );
  return response.data;
};

/**
 * Updates the tire detail with the provided data.
 * @param {BrandDetailTireUpdateRequest} data - The data to update the tire detail.
 * @returns {Promise<void>} A promise that resolves when the update is complete.
 */
const updateTireDetail = async (data: BrandDetailTireUpdateRequest): Promise<void> => {
  const response = await apiClient.post("/mst/item/brand/detail/tire/update", data);
  // if (response.status === 200) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "更新が完了しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
};

export { getTireDetailSelect, updateTireDetail };
